import { useCallback, useRef, useState } from 'react';

export function useSubmitLock() {
  const lockRef = useRef(false);
  const [pending, setPending] = useState(false);

  const tryAcquire = useCallback(() => {
    if (lockRef.current) {
      return false;
    }
    lockRef.current = true;
    setPending(true);
    return true;
  }, []);

  const release = useCallback(() => {
    lockRef.current = false;
    setPending(false);
  }, []);

  const keepLocked = useCallback(() => {
    lockRef.current = true;
    setPending(false);
  }, []);

  const isLocked = useCallback(() => lockRef.current, []);

  return {
    pending,
    tryAcquire,
    release,
    keepLocked,
    isLocked,
  };
}
